<div class="component-container">
  <!-- Anamnesis -->
  <div class="section-container --mt">
    <p class="title">
      {{ "sessions-details.anamnesis" | translate }}
    </p>
    <lib-textarea
      placeholder="{{ 'sessions-details.type-anamnesis' | translate }}"
      [(ngModel)]="medicalRecord.anamnesis"
      (change)="onChangeAnamnesis($event.target.value)"
    ></lib-textarea>
  </div>

  <!-- Digital Prescription Links -->
  <div class="section-container --mt --gray">
    <p class="title">
      {{ "summary-notes.label-digital-prescription" | translate }}
    </p>
    <lib-select
      size="m"
      appearance="white"
      placeholder="{{ 'summary-notes.label-select-option' | translate }}"
      (change)="onChangeHasPrescription($event.target.value)"
      [value]="hasPrescriptionLinks"
      [options]="prescriptionOptions"
    ></lib-select>

    <ul style="margin-top: 12px;" *ngIf="hasPrescriptionLinks === 'true'">
      <li class="section-row">
        <p class="section-header">
          {{ "summary-notes.label-link-prescription" | translate }}
        </p>
      </li>

      <li class="section-row" *ngFor="let link of medicalRecord.links; let linkIndex = index; trackBy: trackByIndex">
        <lib-input
          [(ngModel)]="medicalRecord.links[linkIndex]"
          (ngModelChange)="onChangePrescriptionLinks()"
          required
          appearance="white"
          placeholder="Link"
          [size]="'m'"
        ></lib-input>
        <div class="actions-buttons">
          <button
            *ngIf="medicalRecord.links.length > 1"
            class="row-btn --remove"
            (click)="onClickRemoveLink(linkIndex)"
          >
            <span>+</span>
          </button>
          <button
            class="row-btn --add"
            *ngIf="medicalRecord.links.length - 1 === linkIndex && medicalRecord.links.length < maxLinks"
            (click)="onClickAddNewLink()"
          >
            <span>+</span>
          </button>
        </div>
      </li>
    </ul>
  </div>

  <!-- CID -->
  <div class="section-container --gray">
    <ul>
      <li class="section-row">
        <p class="section-header">
          {{ "sessions-details.insert-CID" | translate }}
        </p>
        <p class="section-header">
          {{ "sessions-details.status" | translate }}
        </p>
      </li>
      <li *ngFor="let cid of medicalRecord.cid; let cidIndex = index" class="section-row">
        <!-- CID Value -->
        <app-spinner-form-control [isLoading]="isCidLoading[cidIndex]">
          <app-cid-select
            (setIsSearching)="setCidIsLoading(cidIndex, $event)"
            [selectedCid]="medicalRecord.cid[cidIndex]"
            (onCidSelected)="onSelectCid(cidIndex, $event)"
            [disabled]="isCidLoading[cidIndex]"
          >
          </app-cid-select>
        </app-spinner-form-control>
        <!-- CID Status -->
        <app-spinner-form-control [isLoading]="isCidLoading[cidIndex]">
          <lib-select
            size="m"
            placeholder="{{ 'sessions-details.select-status' | translate }}"
            (change)="onSelectCidStatus(cidIndex, $event.target.value)"
            [options]="cidStatusOptions"
            [disabled]="medicalRecord.cid[cidIndex].id === null || isCidLoading[cidIndex]"
            [value]="medicalRecord.cid[cidIndex].statusId"
          ></lib-select>
        </app-spinner-form-control>

        <button
          class="row-btn --add"
          [ngClass]="medicalRecord.cid[cidIndex].statusId === null ? 'disabled' : ''"
          [disabled]="medicalRecord.cid[cidIndex].statusId === null"
          *ngIf="medicalRecord.cid.length - 1 === cidIndex"
          (click)="onClickAddCID()"
        >
          <span>+</span>
        </button>
        <button
          class="row-btn --remove"
          *ngIf="medicalRecord.cid.length - 1 !== cidIndex"
          (click)="onClickRemoveCID(cidIndex)"
        >
          <span>+</span>
        </button>
      </li>
    </ul>
  </div>

  <!-- TUSS -->
  <div class="section-container --gray">
    <ul>
      <li class="section-row">
        <p class="section-header">
          {{ "sessions-details.exam-request" | translate }}
        </p>
      </li>
      <li *ngFor="let tuss of medicalRecord.tuss; let tussIndex = index" class="section-row">
        <app-spinner-form-control [isLoading]="isTussLoading[tussIndex]">
          <div class="row-span-2">
            <app-tuss-select
              (onTussSelected)="onSelectTuss(tussIndex, $event)"
              (setIsSearching)="setTussIsLoading(tussIndex, $event)"
              [selectedTuss]="medicalRecord.tuss[tussIndex]"
              [disabled]="isTussLoading[tussIndex]"
            >
            </app-tuss-select>
          </div>
        </app-spinner-form-control>
        <button
          class="row-btn --add"
          [ngClass]="medicalRecord.tuss[tussIndex].id === null ? 'disabled' : ''"
          [disabled]="medicalRecord.tuss[tussIndex].id === null"
          *ngIf="medicalRecord.tuss.length - 1 === tussIndex"
          (click)="onClickAddTuss()"
        >
          <span>+</span>
        </button>
        <button
          class="row-btn --remove"
          *ngIf="medicalRecord.tuss.length - 1 !== tussIndex"
          (click)="onClickRemoveTuss(tussIndex)"
        >
          <span>+</span>
        </button>
      </li>
    </ul>
  </div>

  <!-- Additional Summary Notes -->
  <div class="section-container">
    <p class="title">{{ "sessions-details.additional-notes" | translate }}</p>
    <lib-textarea
      placeholder="{{ 'sessions-details.additional-notes-description' | translate }}"
      [(ngModel)]="medicalRecord.additionalSummaryNotes"
      (change)="onChangeAdditionalSummaryNotes($event.target.value)"
    ></lib-textarea>
  </div>

  <!-- Outcome -->
  <div class="section-container">
    <p class="title">{{ "sessions-details.outcome" | translate }}</p>
    <div class="outcome-input">
      <app-spinner-form-control [isLoading]="isOutcomeLoading">
        <lib-select
          [value]="medicalRecord.outcomeId"
          (change)="onChangeOutcome($event.target.value)"
          size="m"
          [options]="outcomeOptions"
          placeholder="{{ 'sessions-details.select-outcome' | translate }}"
          [disabled]="isOutcomeLoading"
        ></lib-select>
      </app-spinner-form-control>
    </div>
  </div>

  <!-- Submit Button -->
  <footer class="footer">
    <button
      (click)="onClickSubmit()"
      [isPending]="isClosingRequisition"
      [disabled]="isClosingRequisition"
      libButton
      size="m"
    >
      {{ "sessions-details.end-consultation" | translate }}
    </button>
  </footer>
</div>
